import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ESignFormComponent } from './e-sign-form/e-sign-form.component';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';

const routes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'form'
  },
  {
    path: 'form',
    component: ESignFormComponent
  },{
    path: 'order-confirmation/:id',
    component: OrderConfirmationDetailsComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ESignRoutingModule { }
